import { Box, Button, Dialog, Grid, IconButton, Typography } from '@mui/material';
import { MFSubmitButton, MFTextField } from '../../lib/formik';
import { Formik, useFormikContext } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import {
  Distributor,
  getDistributors,
  getDistributorsList,
  getDistributorsForSubdistributor,
  getDistributorsResponse,
  SubDistributor,
  getRmList,
} from '../../redux-store/actions';
import { RmListMdmsType } from '../../redux-store/types/mdms';
import React, { useEffect, useState } from 'react';
import { RootStateType } from '../../redux-store/reducers';
import { updateApplication } from '../../redux-store/actions/application';
import { useHistory } from 'react-router';
import {
  AMC_APPROVER_CHECK_FOR_INDIVIDUAL,
  USER_ROLES,
  subdistributorTypes,
} from '../../utils/constant';
import { InfoDialog, Notes } from './components';
import UseRadioGroup from '../../lib/formik/Radio';
import { distributorsValidationSchema } from '../../utils/schema';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {
  applicationComparison,
  applyRoleBasedStatus,
  checkSubDisDisable,
  checkSupportLogin,
  filledByMandatoryFields,
} from '../../utils/utilityFunctions';
import { SearchableSelect } from '../../lib/formik/searchSelectField';
import { ConfirmationDialog } from '../commonComponents';
import { DistributorListType, SubDistributorListType } from '../../redux-store/types/api-types';
import { getDistributorById, getDistributorRMbyId } from '../../redux-store/actions/userManagement';
import { getDirectApplicableFunds } from '../../redux-store/actions/funds';
import { FundProps } from '../../redux-store/types/funds';
import Loader from '../../utils/Loader';

type DistributorDetailsProps = {
  distributorName: string | null;
  distributorId: number | null;
  loginType: string;
  firstName: string;
  empCode: string;
  email: string;
  subdistributorId: number | null;
  subdistributorName: string | null;
  supportSubdistributorId: string | null | number;
  supportDistributorEmail: string | null;
  subdistributorEmail: string | null;
  filledBy: string | null;
  distributorArnCode: string | null;
  supportDistributorCode: string | null;
  subDisCode: string | null;
  rmName: string | null;
};

export function GridItem({ children }: { children: React.ReactNode }) {
  return (
    <Grid item xs={12} sm={6}>
      {children}
    </Grid>
  );
}

const RMDetail = ({ rmList }: { rmList: RmListMdmsType[] }) => {
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const { values, setFieldValue } = useFormikContext<DistributorDetailsProps>();
  return (
    <>
      {role !== USER_ROLES.INVESTOR && (
        <>
          <GridItem>
            <MFTextField
              name="firstName"
              label="RM Name"
              placeholder="Enter RM name"
              disabled={true}
            />
          </GridItem>
          <GridItem>
            <MFTextField
              name="email"
              label="RM Email ID"
              placeholder="Enter RM Email ID"
              disabled={true}
            />
          </GridItem>
        </>
      )}
      {[USER_ROLES.AMC_ADMIN, USER_ROLES.INVESTOR].includes(role) && (
        <GridItem>
          <SearchableSelect
            name="rmName"
            label="Marcellus RM Name"
            items={[...rmList]
              .sort((rm1, rm2) => (rm1.label || '').localeCompare(rm2.label || ''))
              .map((item) => ({
                key: item.label || 'NA',
                value: item.value,
              }))}
            onChange={({ target: { value } }) => {
              setFieldValue('rmName', value as string);
            }}
            searchFieldPlaceholder={'Search RM'}
          />
        </GridItem>
      )}
      {/* <GridItem>
        <MFTextField
          name="empCode"
          label="Employee Code"
          placeholder="Enter Employee Code"
          disabled={true}
        />
      </GridItem> */}
    </>
  );
};

const DistributorDetail = ({
  distributors,
  values,
  selectedDistributor,
  setSelectedDistributor,
  selectSupport,
  setSelectSupport,
}: {
  distributors: Distributor[];
  values: DistributorDetailsProps;
  selectedDistributor: SubDistributor[];
  selectSupport: SubDistributor[];
  setSelectSupport: (distributor: SubDistributor[]) => void;
  setSelectedDistributor: (distributor: SubDistributor[]) => void;
}): JSX.Element => {
  const { role } = useSelector((store: RootStateType) => store.auth);
  const { setValues } = useFormikContext();
  const [open, setOpen] = useState(false);
  const [openDialog, setDialog] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleDialogOpen = () => {
    setDialog(true);
  };
  const handleDialogClose = () => {
    setDialog(false);
  };
  const { application } = useSelector((store: RootStateType) => store.application);
  const auth = useSelector((store: RootStateType) => store.auth);

  return (
    <>
      {distributors.length > 0 ? (
        <>
          {[USER_ROLES.RM, USER_ROLES.INVESTOR].includes(role) &&
            values.distributorId &&
            !application?.createdByNFO && (
              <Grid item xs={12} sx={{ textAlign: 'right' }}>
                <Button
                  variant="contained"
                  sx={{
                    color: 'white',
                    fontWeight: 500,
                    fontSize: 14,
                    py: 0.5,
                    px: 3,
                  }}
                  onClick={handleDialogOpen}>
                  clear
                </Button>
              </Grid>
            )}
          <GridItem>
            <SearchableSelect
              name="distributorId"
              label="Distributor Name *"
              items={distributors
                .sort((distributor1, distributor2) =>
                  (distributor1['name'] || '')
                    .toString()
                    .localeCompare((distributor2['name'] || '').toString())
                )
                .map((item) => ({
                  key: item.name || 'NA',
                  // + ' - ' + (item.arnCode || 'NA'),
                  value: item.id,
                }))}
              renderValuePosition={0}
              onChange={({ target: { value } }) => {
                const distributorCode = distributors.find((item) => item.id === value);
                const { id = null, name, arnCode } = distributorCode || {};
                setValues({
                  ...values,
                  distributorName: name,
                  distributorArnCode: arnCode || 'NA',
                  distributorId: id,
                  subdistributorId: null,
                  subDisCode: null,
                  subdistributorName: null,
                  subdistributorEmail: null,
                  supportDistributorEmail: '',
                  supportDistributorCode: '',
                  supportSubdistributorId: null,
                });
                setSelectedDistributor(
                  distributors
                    ?.find((distributor) => distributor.id === value)
                    ?.subdistributors?.filter(
                      (ele) =>
                        subdistributorTypes[ele.subdistributorType || ''] ===
                        subdistributorTypes.direct
                    ) || []
                );
                setSelectSupport(
                  distributors
                    ?.find((distributor) => distributor.id === value)
                    ?.subdistributors?.filter(
                      (ele) =>
                        subdistributorTypes[ele.subdistributorType || ''] ===
                        subdistributorTypes.support
                    ) || []
                );
              }}
              disabled={
                [
                  USER_ROLES.DISTRIBUTOR,
                  USER_ROLES.POAAPPROVER,
                  USER_ROLES.SUBDISTRIBUTOR,
                ].includes(role) || application?.createdByNFO
              }
              applyRenderValue={true}
              searchFieldPlaceholder={'Search Distributor'}
            />
          </GridItem>
          <GridItem>
            <MFTextField
              name="distributorArnCode"
              label="Distributor Code"
              placeholder="Enter Distributor Code"
              disabled={true}
            />
          </GridItem>
          {/* <GridItem>
            <MFTextField
              name="distributorName"
              label="Distributor Name *"
              placeholder="Enter Distributor name"
              disabled={true}
            />
          </GridItem> */}
          {!application?.createdByNFO && (
            <>
              {!!selectedDistributor?.length && (
                <>
                  <GridItem>
                    <SearchableSelect
                      name="subdistributorId"
                      label="Distributor's RM Name *"
                      items={selectedDistributor
                        .sort((subDistributor1, subDistributor2) =>
                          (subDistributor1.user['firstName'] || '')
                            .toString()
                            .localeCompare((subDistributor2.user['firstName'] || '').toString())
                        )
                        .map((item) => ({
                          key: item.user.firstName || 'NA',
                          // ' - ' + (item.distributors_RM_Code || 'NA'),
                          value: item.id,
                        }))}
                      onChange={({ target: { value } }) => {
                        const distributorCode = selectedDistributor.find(
                          (item) => item.id === value
                        );
                        const { id = null, user, distributors_RM_Code } = distributorCode || {};
                        const { email } = user || {};
                        setValues({
                          ...values,
                          subdistributorId: id,
                          subdistributorEmail: email,
                          subDisCode: (distributors_RM_Code || '').trim() || 'NA',
                        });
                      }}
                      disabled={
                        checkSubDisDisable(
                          role,
                          auth.id || '',
                          application?.supportSubdistributor?.user?.id || ''
                        ) ||
                        (auth.id == application?.createdBy &&
                          application?.subDistributor?.userId === auth.id) ||
                        auth.id != application?.createdBy
                      }
                      searchFieldPlaceholder={"Search Distributor's RM"}
                    />
                  </GridItem>
                  {/* <GridItem>
            <MFTextField
              name="subdistributorName"
              label="Distributor's RM Name *"
              placeholder="Enter Distributor name"
              disabled={true}
            />
          </GridItem> */}
                  <GridItem>
                    <MFTextField
                      name="subDisCode"
                      label="Distributor's RM Code *"
                      placeholder="Enter Distributor's RM Code"
                      disabled={true}
                    />
                  </GridItem>
                  <GridItem>
                    <MFTextField
                      name="subdistributorEmail"
                      label="Distributor's RM Email *"
                      placeholder="Enter Distributor email"
                      disabled={true}
                    />
                  </GridItem>
                </>
              )}
              {!!selectSupport?.length && (
                <>
                  <GridItem>
                    <SearchableSelect
                      name="supportSubdistributorId"
                      label="CSE Name *"
                      items={selectSupport
                        ?.sort((support1, support2) =>
                          (support1.user['firstName'] || 'NA')
                            ?.toString()
                            .localeCompare((support2.user['firstName'] || '').toString())
                        )
                        ?.map((item) => ({
                          key: item?.user?.firstName || 'NA',
                          value: item?.id || '',
                        }))}
                      searchFieldPlaceholder={'Search CSE Name'}
                      onChange={async ({ target: { value } }) => {
                        try {
                          setLoading(true);
                          const user = selectSupport.find(
                            (item) => Number(item.id) === Number(value)
                          );
                          setValues({
                            ...values,
                            supportSubdistributorId: user?.id,
                            // subDisCode: user?.user?.firstName || '',
                            supportDistributorEmail: user?.user?.email || '',
                            supportDistributorCode:
                              (user?.distributors_RM_Code || '').trim() || 'NA',
                          });
                          setLoading(false);
                        } catch (e: unknown) {
                          setLoading(false);
                          console.error((e as Error).message);
                        }
                      }}
                      disabled={
                        (auth.id == application?.createdBy &&
                          application?.supportSubdistributor?.userId === auth.id) ||
                        auth.id != application?.createdBy
                      }
                      // disabled={true}
                    />
                  </GridItem>
                  <GridItem>
                    <MFTextField
                      name="supportDistributorCode"
                      label="CSE Code *"
                      placeholder="Enter CSE Code"
                      disabled={true}
                    />
                  </GridItem>
                  <GridItem>
                    <MFTextField
                      name="supportDistributorEmail"
                      label="CSE Email *"
                      placeholder="Enter CSE Email"
                      disabled={true}
                    />
                  </GridItem>
                </>
              )}
            </>
          )}
          <GridItem>
            <MFTextField
              name="filledBy"
              label={`Filled by ${filledByMandatoryFields(values.distributorId, role) ? ' *' : ''}`}
              placeholder="Enter filled by"
              infoText="Please add the Name of the Subdistributor RM."
            />
            {/* <Typography
              component="span"
              sx={{ position: 'relative', left: 64, bottom: { xs: 85, md: 91 } }}>
              <InfoOutlinedIcon color="info" fontSize="small" onClick={handleOpen} />
            </Typography> */}
          </GridItem>
          {/* <InfoDialog
            onClose={handleClose}
            open={open}
            content={'Please add the Name of the Subdistributor RM.'}
          /> */}
        </>
      ) : (
        <Grid
          xs={12}
          sm={12}
          sx={{
            fontSize: 18,
            fontWeight: 500,
            color: 'rgb(97, 209, 214)',
            display: 'flex',
            alignItems: 'center',
            textAlign: 'center',
            justifyContent: 'center',
            mt: { lg: 9, xs: 9 },
            mb: 2.9,
            ml: { xs: 3 },
          }}>
          No distributor mapped under this RM
        </Grid>
      )}
      <ConfirmationDialog
        message={`Are you sure you want to clear Distributor details ?`}
        open={openDialog}
        setOpen={handleDialogClose}
        onSave={() => {
          handleDialogClose();
          setValues({
            ...values,
            distributorName: '',
            distributorArnCode: null,
            distributorId: null,
            subdistributorId: null,
            subdistributorName: '',
            subdistributorEmail: '',
            supportDistributorEmail: '',
            supportDistributorCode: '',
            supportSubdistributorId: null,
            subDisCode: null,
          });
          setSelectedDistributor([]);
          setSelectSupport([]);
        }}
        onCancel={handleDialogClose}
      />
    </>
  );
};

export default function DistributorDetails(): JSX.Element {
  const dispatch = useDispatch();
  const history = useHistory();
  const [distributors, setDistributors] = useState<Distributor[]>([]);
  const { application } = useSelector((store: RootStateType) => store.application);
  const { role } = useSelector((store: RootStateType) => store.auth);
  const [selectedDistributor, setSelectedDistributor] = useState<SubDistributor[]>([]);
  const [rmList, setRmList] = useState<RmListMdmsType[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const {
    distributor,
    rm,
    subdistributorId = null,
    subDistributor,
    filledBy = '',
    flowType = '',
    supportSubdistributorId = null,
    supportSubdistributor,
    createdByNFO = false,
  } = application || {};

  const { name, id, arnCode } = distributor || {
    arnCode: '',
    name: '',
    id: null,
  };

  const {
    empCode,
    user: { email: RMEmail = '', firstName: RMFirstName = '' },
  } = rm || { empCode: '', user: { email: '' } };

  const {
    user: { firstName: subdistributorName, email: subdistributorEmail },
    distributors_RM_Code: subDistributorRMCode,
  } = subDistributor || { user: { firstName: '', email: '' }, distributors_RM_Code: '' };

  const { user, distributors_RM_Code = 'NA' } = supportSubdistributor || {};
  const [selectSupport, setSelectSupport] = useState<SubDistributor[]>([]);
  const { auth } = useSelector((store: RootStateType) => store);
  const initialValues: DistributorDetailsProps = {
    distributorId: id,
    distributorName: name,
    loginType: !createdByNFO ? 'rm' : 'distributor',
    empCode,
    email: RMEmail,
    firstName: RMFirstName,
    subdistributorId: subdistributorId === null ? subdistributorId : Number(subdistributorId),
    subdistributorName,
    subdistributorEmail,
    filledBy,
    distributorArnCode: id ? arnCode || 'NA' : null,
    supportSubdistributorId:
      supportSubdistributorId === null ? supportSubdistributorId : Number(supportSubdistributorId),
    supportDistributorEmail: user?.email || '',
    supportDistributorCode: (distributors_RM_Code || '').trim() || 'NA',
    subDisCode: (subDistributorRMCode || '').trim() || 'NA',
    rmName: application?.rmName || null,
  };

  useEffect(() => {
    setLoading(true);
    let isComponentActive = true;
    (async function () {
      try {
        if (
          Object.keys(application || {}).length &&
          [USER_ROLES.RM, USER_ROLES.SUBDISTRIBUTOR, USER_ROLES.AMC_ADMIN].includes(role)
        ) {
          let distributors = [];
          if (USER_ROLES.RM !== role) {
            distributors = (await dispatch(
              getDistributorsForSubdistributor({
                isActive: true,
                rmId: Number(application?.rm_id),
                distributorId: Number(application?.distributor_id),
              })
            )) as unknown as Distributor[];
          } else {
            const res = (await dispatch(
              getDistributors({ isActive: true })
            )) as unknown as getDistributorsResponse;
            distributors = res.distributors || [];
          }
          const updatedDistributor =
            application?.distributor_id && !application.distributor.isActive
              ? [
                  ...distributors,
                  {
                    ...application.distributor,
                    subdistributors: application?.subdistributorId
                      ? [application.subDistributor]
                      : application.subDistributor,
                  } as Distributor,
                ]
              : distributors;
          if (isComponentActive) {
            const updateSubdistributor = (
              application?.distributor_id &&
              application?.distributor.isActive &&
              application?.subdistributorId &&
              !application.subDistributor?.isActive
                ? [
                    ...(updatedDistributor.find(
                      (distributor) => Number(distributor.id) === Number(id)
                    )?.subdistributors || []),
                    { ...application.subDistributor },
                  ]
                : updatedDistributor.find((distributor) => Number(distributor.id) === Number(id))
                    ?.subdistributors || []
            )
              .filter((ele) => ele)
              .filter(
                (ele) =>
                  subdistributorTypes[ele.subdistributorType || ''] === subdistributorTypes.direct
              );
            const updatedsupportSubdistributor = (
              application?.distributor_id &&
              application?.distributor.isActive &&
              application?.supportSubdistributorId &&
              !application.supportSubdistributor?.isActive
                ? [
                    ...(updatedDistributor.find(
                      (distributor) => Number(distributor.id) === Number(id)
                    )?.subdistributors || []),
                    { ...application.supportSubdistributor },
                  ]
                : updatedDistributor.find((distributor) => Number(distributor.id) === Number(id))
                    ?.subdistributors || []
            )
              .filter((ele) => ele)
              .filter(
                (ele) =>
                  subdistributorTypes[ele.subdistributorType || ''] === subdistributorTypes.support
              );
            setSelectSupport(updatedsupportSubdistributor as unknown as SubDistributor[]);
            setSelectedDistributor(updateSubdistributor as unknown as SubDistributor[]);
            setDistributors(updatedDistributor as unknown as Distributor[]);
          }
        } else if (
          application &&
          supportSubdistributor &&
          checkSupportLogin(Number(auth.id), supportSubdistributor?.user.id)
        ) {
          const { distributor } = application || {};
          setDistributors(distributor ? [distributor as Distributor] : []);
          setSelectSupport(
            [application?.supportSubdistributor as unknown as SubDistributor].filter((ele) => ele)
          );
          const getDistributorRmDetails = (await dispatch(
            getDistributorRMbyId(Number(application?.supportSubdistributorId))
          )) as unknown as SubDistributorListType;
          setSelectedDistributor(
            getDistributorRmDetails?.directSubdistributorsDetails
              .directSubdistributors as unknown as SubDistributor[]
          );
        } else if (role === USER_ROLES.INVESTOR && Object.keys(application || {}).length) {
          const distributors = (await dispatch(getDistributorsList())) as unknown as Distributor[];
          const updatedDistributor =
            application?.distributor_id && !application.distributor.isActive
              ? [
                  ...distributors,
                  {
                    ...application.distributor,
                    subdistributors: application?.subdistributorId
                      ? [application.subDistributor]
                      : application.subDistributor,
                  } as Distributor,
                ]
              : distributors;
          if (isComponentActive) {
            const updateSubdistributor = (
              application?.distributor_id &&
              application?.distributor.isActive &&
              application?.subdistributorId &&
              !application.subDistributor?.isActive
                ? [
                    ...(updatedDistributor.find(
                      (distributor) => Number(distributor.id) === Number(id)
                    )?.subdistributors || []),
                    { ...application.subDistributor },
                  ]
                : updatedDistributor.find((distributor) => Number(distributor.id) === Number(id))
                    ?.subdistributors || []
            )
              .filter((ele) => ele)
              .filter(
                (ele) =>
                  subdistributorTypes[ele.subdistributorType || ''] === subdistributorTypes.direct
              );
            const updatedsupportSubdistributor = (
              application?.distributor_id &&
              application?.distributor.isActive &&
              application?.supportSubdistributorId &&
              !application.supportSubdistributor?.isActive
                ? [
                    ...(updatedDistributor.find(
                      (distributor) => Number(distributor.id) === Number(id)
                    )?.subdistributors || []),
                    { ...application.supportSubdistributor },
                  ]
                : updatedDistributor.find((distributor) => Number(distributor.id) === Number(id))
                    ?.subdistributors || []
            )
              .filter((ele) => ele)
              .filter(
                (ele) =>
                  subdistributorTypes[ele.subdistributorType || ''] === subdistributorTypes.support
              );
            setSelectSupport(updatedsupportSubdistributor as unknown as SubDistributor[]);
            setSelectedDistributor(updateSubdistributor as unknown as SubDistributor[]);
            setDistributors(updatedDistributor as unknown as Distributor[]);
          }
        } else if (role !== USER_ROLES.INVESTOR) {
          const { distributor, subDistributor } = application || {};
          setDistributors(distributor ? [distributor as Distributor] : []);
          setSelectSupport(
            [application?.supportSubdistributor as unknown as SubDistributor].filter((ele) => ele)
          );
          setSelectedDistributor(
            subDistributor
              ? [{ ...subDistributor, id: Number(subDistributor.id) } as unknown as SubDistributor]
              : []
          );
        }
      } catch (e: unknown) {
        console.error((e as Error).message);
      } finally {
        setLoading(false);
      }
    })();
    return () => {
      isComponentActive = false;
    };
  }, [application, role, auth, supportSubdistributor]);

  useEffect(() => {
    let isComponentActive = true;
    (async function () {
      try {
        const res = (await dispatch(getRmList())) as unknown as RmListMdmsType[];
        if (isComponentActive) {
          setRmList(res || []);
        }
      } catch (e: unknown) {
        console.error((e as Error).message);
      }
    })();
    return () => {
      isComponentActive = false;
    };
  }, []);

  const onSubmit = async (values: DistributorDetailsProps) => {
    try {
      const { distributorId, subdistributorId, supportSubdistributorId, filledBy, rmName } = values;
      const { id, applicant1ReferenceId, currentStep = null, status, hasPOA } = application || {};
      const checkApplication = applicationComparison(application, {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        ...application!,
        distributor_id: distributorId,
        subdistributorId: subdistributorId ? subdistributorId.toString() : subdistributorId,
        supportSubdistributorId: supportSubdistributorId,
        rmName: rmName,
        filledBy: filledBy,
        currentStep: currentStep === null ? 1 : currentStep,
      });
      let restSchemePlan = {};
      const isDistributorExists =
        !distributorId &&
        application?.distributor_id &&
        (application?.schemeId || application?.planId);
      if (distributorId || isDistributorExists) {
        let getPlanId: any[] = [];
        if (Number(distributorId) !== Number(application?.distributor_id) && distributorId) {
          getPlanId = (
            (await dispatch(
              getDistributorById(distributorId, { isActive: true })
            )) as unknown as DistributorListType
          )?.planDetails.planIds;
        } else if (isDistributorExists) {
          (
            (await dispatch(getDirectApplicableFunds({ isActive: true }))) as unknown as FundProps[]
          )?.map((fund) => {
            getPlanId.push(
              ...fund.plans?.filter((fund) => fund.isApplicableForDirect)?.map((plan) => plan.id)
            );
            return fund;
          });
        }
        if (
          application?.planId &&
          !getPlanId.map((ele) => ele?.toString()).includes(application?.planId?.toString())
        ) {
          //reset whatEver Fields used in investmentPayment details section
          restSchemePlan = {
            schemeId: null,
            planId: null,
            commitmentAmount: 0,
            setupFeePercentage: 0,
            managementFeesRate: 0,
            contributionChequeAmount: 0,
            taxRate: 0,
            drawDownNumber: 0,
            hurdleRateOfReturns: '',
            performanceFee: '',
            commitmentAmountForMigration: '',
            contributionAmountForMigration: '',
          };
        }
      }
      if (id && !checkApplication) {
        await dispatch(
          updateApplication({
            body: {
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              ...application!,
              distributor_id: distributorId,
              subdistributorId,
              supportSubdistributorId,
              rmName,
              ...restSchemePlan,
              status:
                !hasPOA &&
                AMC_APPROVER_CHECK_FOR_INDIVIDUAL &&
                status !== 'draft' &&
                applyRoleBasedStatus(role)
                  ? 'sent_to_amc_approver'
                  : status,
              currentStep: 1,
              //currentStep === null ? 1 : currentStep
              filledBy,
            },
            applicationId: id,
            flowType,
          })
        );
        history.push('contributor-details', { id, applicant1ReferenceId });
      } else if (checkApplication) {
        history.push('contributor-details', { id, applicant1ReferenceId });
      }
    } catch (e) {
      console.error((e as Error).message);
    }
  };

  return !application?.createdAt || loading ? (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        bgcolor: 'white',
        zIndex: 9999, // Ensures it's above all other content
      }}>
      <Loader size={60} speed={2} />
    </Box>
  ) : (
    <Formik
      initialValues={initialValues}
      validationSchema={distributorsValidationSchema(
        selectedDistributor,
        selectSupport,
        distributors,
        role,
        !!application?.createdByNFO
      )}
      onSubmit={onSubmit}
      enableReinitialize={true}>
      {({ handleSubmit, values }) => (
        <Box component="form" noValidate onSubmit={handleSubmit}>
          {![USER_ROLES.DISTRIBUTOR, USER_ROLES.SUBDISTRIBUTOR].includes(role) && !createdByNFO && (
            <Notes
              displayContent={
                'This section specifies whether the application is from an Direct or Distributor Channel.'
              }
            />
          )}
          <Grid container rowSpacing={2} columnSpacing={5}>
            {[USER_ROLES.RM, USER_ROLES.INVESTOR].includes(role) && (
              <Grid item xs={12}>
                <UseRadioGroup
                  formLabel=""
                  name={`loginType`}
                  items={
                    createdByNFO
                      ? [{ label: 'Distributor', value: USER_ROLES.DISTRIBUTOR }]
                      : [
                          { label: 'Direct', value: USER_ROLES.RM },
                          { label: 'Distributor', value: USER_ROLES.DISTRIBUTOR },
                        ]
                  }
                  disabled={createdByNFO}
                />
              </Grid>
            )}
            {![USER_ROLES.DISTRIBUTOR, USER_ROLES.SUBDISTRIBUTOR, USER_ROLES.POAAPPROVER].includes(
              role
            ) && values.loginType === USER_ROLES.RM ? (
              <RMDetail rmList={rmList} />
            ) : (
              <DistributorDetail
                distributors={distributors}
                values={values}
                selectSupport={selectSupport}
                setSelectSupport={setSelectSupport}
                selectedDistributor={selectedDistributor}
                setSelectedDistributor={(subdistributors) =>
                  setSelectedDistributor(subdistributors)
                }
              />
            )}
          </Grid>
          <Box sx={{ width: '100%', maxWidth: '350px', mx: 'auto', mt: 5 }}>
            <MFSubmitButton label="Next" />
          </Box>
        </Box>
      )}
    </Formik>
  );
}
